<script setup lang="ts">
withDefaults(defineProps<{ disableButtons: boolean }>(), {
  disableButtons: true,
});

const { $t } = useNuxtApp();

const emits = defineEmits<{ (e: 'reset'): void; (e: 'confirm'): void }>();
</script>

<template>
  <div class="flex gap-2 p-4 bg-light-200 dark:bg-dark-700">
    <DesignSystemButton
      :disabled="!disableButtons"
      class="justify-center items-center w-1/2"
      type="tertiary"
      padding="wide"
      @click="emits('reset')"
    >
      {{ $t('reset') }}
    </DesignSystemButton>
    <DesignSystemButton
      :disabled="!disableButtons"
      class="justify-center items-center w-1/2"
      type="primary"
      padding="wide"
      @click="emits('confirm')"
    >
      {{ $t('confirm') }}
    </DesignSystemButton>
  </div>
</template>
